import { makeStyles } from '@mui/styles';
import { type Theme, Grid } from '@mui/material';
import MainPageLayout, {type MainPageLayoutProps} from 'layouts/MainPageLayout';

const useStyles = makeStyles((theme: Theme) => ({
  menuGrid: {
    [theme.breakpoints.up('md')]: {
      padding: 50,
    },
  },
}), { name: 'MenuGridPageLayout' });

export type MenuGridPageLayoutProps = MainPageLayoutProps;

const MenuGridPageLayout = ({ children, title } : MenuGridPageLayoutProps): JSX.Element => {
  const classes = useStyles();
  return (
    <MainPageLayout title={title}>
      <Grid alignItems='stretch' className={classes.menuGrid} container>
        {children}
      </Grid>
    </MainPageLayout>
  );
}

export default MenuGridPageLayout;
